<template>
    <section class="py-12 md:py-16 lg:py-20 mb-20 lg:mb-0 p-5 sm:p-10 lg:p-20 bg-gradient-to-b from-gray-100 to-gray-200 rounded-lg shadow-inner">
        <div class="mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <!-- Textbereich -->
            <div>
                <h2 class="mb-4">{{ title }}</h2>
                <div class="text-gray-600 mb-8" v-html="description"></div>

                <div class="flex flex-col gap-6">
                    <FeatureItem v-for="(feature, idx) in features" :key="idx" :title="feature.title" :desc="feature.desc" />
                </div>
            </div>

            <!-- Bildbereich -->
            <div class="relative">
                <div class="overflow-hidden rounded-2xl shadow-lg bg-gradient-to-b from-gray-800 to-gray-700 flex items-center justify-center h-80">
                    <img :src="imageSrc" :alt="imageAlt" class="object-cover lg:object-fill w-full h-full bg-white" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import FeatureItem from './FeatureItem.vue';

export default {
    name: 'ProductAnalysisSection',
    components: {
        FeatureItem
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        features: {
            type: Array,
            required: true
        },
        imageSrc: {
            type: String,
            required: true
        },
        imageAlt: {
            type: String,
            default: 'Chart Illustration'
        }
    }
};
</script>
